import type { PropsWithChildren } from "react";

export function ModalTableWrapper({ children }: PropsWithChildren) {
	/** Render */
	return <div className="h-[80vh] max-h-[700px]">{children}</div>;
}
